export { }

declare global {
  interface Date {
    isSameDate(date: Date): boolean;
    isToday(): boolean;

    isAfter(date: Date): boolean;
    isBefore(date: Date): boolean;

    plusSeconds(hours: number): void;
    minusSeconds(hours: number): void;

    plusMinutes(hours: number): void;
    minusMinutes(hours: number): void;

    plusHours(hours: number): void;
    minusHours(hours: number): void;

    plusDays(days: number): void;
    minusDays(days: number): void;

    plusMonths(months: number): void;
    minusMonths(months: number): void;

    midnight(): void;
    dayEnd(): void;
  }
}

Date.prototype.isSameDate = function (date: Date): boolean {
  if (!date || date.constructor.name !== 'Date') {
    return false;
  }

  return date && this.getFullYear() === date.getFullYear() &&
    this.getMonth() === date.getMonth() && this.getDate() === date.getDate();
};

Date.prototype.isToday = function (): boolean {
  const today = new Date();
  return this.isSameDate(today);
};

Date.prototype.isAfter = function (date: Date): boolean {
  if (!date || date.constructor.name !== 'Date') {
    return false;
  }
  return this.getTime() > date.getTime();
};

Date.prototype.isBefore = function (date: Date): boolean {
  if (!date || date.constructor.name !== 'Date') {
    return false;
  }

  return this.getTime() < date.getTime();
};

Date.prototype.plusSeconds = function (seconds: number): void {
  if (!seconds) return;

  const miliseconds = seconds * 1000;
  this.setTime(this.getTime() + miliseconds);
};

Date.prototype.minusSeconds = function (seconds: number): void {
  if (!seconds) return;

  const miliseconds = seconds * 1000;
  if (this.getTime() > miliseconds)
    this.setTime(this.getTime() - miliseconds);
  else
    this.setTime(0);
};

Date.prototype.plusMinutes = function (minutes: number): void {
  if (!minutes) return;

  const miliseconds = minutes * 60 * 1000;
  this.setTime(this.getTime() + miliseconds);
};

Date.prototype.minusMinutes = function (minutes: number): void {
  if (!minutes) return;

  const miliseconds = minutes * 60 * 1000;
  if (this.getTime() > miliseconds)
    this.setTime(this.getTime() - miliseconds);
  else
    this.setTime(0);
};

Date.prototype.plusHours = function (hours: number): void {
  if (!hours) return;

  const miliseconds = hours * 60 * 60 * 1000;
  this.setTime(this.getTime() + miliseconds);
};

Date.prototype.minusHours = function (hours: number): void {
  if (!hours) return;

  const miliseconds = hours * 60 * 60 * 1000;
  if (this.getTime() > miliseconds)
    this.setTime(this.getTime() - miliseconds);
  else
    this.setTime(0);
};

Date.prototype.plusDays = function (days: number): void {
  if (!days) return;

  const miliseconds = days * 24 * 60 * 60 * 1000;
  this.setTime(this.getTime() + miliseconds);
};

Date.prototype.minusDays = function (days: number): void {
  if (!days) return;

  const miliseconds = days * 24 * 60 * 60 * 1000;
  if (this.getTime() > miliseconds)
    this.setTime(this.getTime() - miliseconds);
  else
    this.setTime(0);
};

Date.prototype.plusMonths = function (months: number): void {
  if (!months) return;

  if (months > 12) {
    this.setFullYear(this.getFullYear() + ~~(months / 12));
    this.setMonth(this.getMonth() + months % 12);
  }
  else
    this.setMonth(this.getMonth() + months);
};

Date.prototype.minusMonths = function (months: number): void {
  if (!months) return;

  if (months > 12) {
    this.setFullYear(this.getFullYear() - ~~(months / 12));
    this.setMonth(this.getMonth() - months % 12);
  }
  else
    this.setMonth(this.getMonth() - months);
};

Date.prototype.midnight = function (): void {
  this.setHours(0, 0, 0, 0);
};

Date.prototype.dayEnd = function (): void {
  this.setHours(23, 59, 59, 999);
};
